// extracted by css-extract-rspack-plugin
export default {"username":"lgtCX1","deviation-title":"LzgcH7","deviationTitle":"LzgcH7","status-active":"xxB_cP","statusActive":"xxB_cP","status-cancelled":"EvAEoj","statusCancelled":"EvAEoj"};